import React, { useEffect, useRef, useState } from "react";
import style from "./InputSearch.module.scss";
import { ReactComponent as SearchIcon} from "./searchIcon.svg";
import { useLocation } from "react-router-dom";

interface InputProps {
    props?: any;
    label?: any;
    name?: string;
    value?: any;
    multiline?: boolean;
    fullWidth?: boolean;
    onChange?: Function;
    onKeyDown?: Function
    handleSearch?: Function
    placeholder?: string
}
const InputDelay = ({
    props,
    label,
    name,
    value,
    multiline,
    fullWidth,
    handleSearch,
    onKeyDown,
    placeholder,
}: InputProps) => {
    const location = useLocation();
    const search = location.search;
    const searchParams = new URLSearchParams(search);
    const searchParam = searchParams.get("search") || "";
    function usePreviousValue(value: any) {
      const ref = useRef();
      useEffect(() => {
          ref.current = value || "";
      });
      return ref.current;
    }
    useEffect(()=>{
        setQuery(searchParam)
    }, [location])
    const [query, setQuery] = useState(searchParam);
    const prevQuery = usePreviousValue(query || "");
    // useEffect(() => {
    //     //@ts-ignore
    //     const timeOutId = setTimeout(() => onChange && onChange(query), 500);
    //     return () => clearTimeout(timeOutId);
    // }, [query]);
    //@ts-ignore
    const onChangeInput = (event) => {
        setQuery(event.target.value);
    };
    //@ts-ignore
    const onKeyDownSearch = (e) => {
        if(onKeyDown) {
            onKeyDown(e)
        } else {
            if (e.keyCode === 13) {
              if(query !== prevQuery) {
                handleSearch && handleSearch(query);
              }
            }
        }
    };
    const handleClickSearch = () => {
        if(query !== prevQuery) {
          handleSearch && handleSearch(query)
        }
    };
    return (
      <div
        className={style["InputDelayWrapper"] + " InputDelayWrapper"}>
        <input
          {...props}
          label={label}
          name={name}
          multiline={multiline}
          fullWidth={fullWidth}
          onChange={onChangeInput}
          value={query}
          onKeyDown={onKeyDownSearch}
          placeholder={placeholder}
        />
        <div
          className="pointer"
          role="presentation"
          onClick={handleClickSearch}
        >
          <SearchIcon />
        </div>
      </div>
    );
};

export default InputDelay;
